import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import styled from '@emotion/styled';

const useStyles = makeStyles({
    root: {
        textAlign: 'center',
        padding: 10,
    },
    black: {
        backgroundColor: '#525252',
    },
});
const HeadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 5px;
`
const Heading = styled.div`
  color: #3E3E3E;
`
const HeadingRed = styled.div`
  color: #DA4453;
`
const Description = styled.div`
font-size: .8em;
font-weight: 300;
`

function CardContent(props: any) {
    const classes = useStyles();
    return(
        <Paper className={classes.root} elevation={props.shadow? props.shadow: 0}>
            <HeadingWrapper>
                <HeadingRed>{props.redHeading}</HeadingRed>&nbsp;
                <Heading>{props.heading}</Heading>
            </HeadingWrapper>
            <Description>
                {props.description}
            </Description>

        </Paper>
 
    );
}

export default CardContent;
